<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <NeList ref='neList' :neArr='netype' :select='neClick'></NeList>
    </template>
    <template v-slot:right_view>
      <PviTableMenu ref="menuInfo" @methodEnum='methodEnum'></PviTableMenu>
      <PviTable ref="pviTable"></PviTable>
    </template>
  </BasicLayout>
</template>

<script>
import PviTable from '../../../../components/subscriberconfig/vonrSubscriber/pvi/PviTable';
import PviTableMenu from '../../../../components/subscriberconfig/vonrSubscriber/pvi/PviTableMenu';
import BasicLayout from '../../../../layouts/BasicLayout';
import NeList from '../../../../components/common/NeListNoIP';

export default {
  name: 'PviMainPage',
  components: {
    NeList,
    PviTable,
    PviTableMenu,
    BasicLayout,
  },
  data() {
    return {
      left: {
        show: true,
        name: this.$t("LteUser.nelist"),
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: this.$t("Pvi.crumb"),
      },
      netype: [43],
    };
  },
  methods: {
    methodEnum(opcode, params) {
      switch (opcode) {
        case 'add':
          this.$refs.pviTable.openAddPviPage();
          break;
        case 'addBatch':
          this.$refs.pviTable.openAddBatchPviPage();
          break;
        case 'mod':
          this.$refs.pviTable.openModPviPage();
          break;
        case 'del':
          this.$refs.pviTable.delUsers();
          break;
        case 'qry':
          this.$refs.menuInfo.setSearchString();
          this.$refs.pviTable.refreshData();
          break;
        case 'chg':
          this.$refs.pviTable.setfilter(params);
          break;
        case 'src':
          this.$refs.pviTable.filterData();
          break;
        case 'qryPuiByPvi':
          this.$refs.pviTable.openQryPuiByPviPage();
          break;
        default:
      }
    },
    neClick(ne) {
      this.$refs.pviTable.getGridData(this.$refs.neList.getNe());
    }
  }
};
</script>

<style scoped>

</style>
